export const formatPara = (para: string) => {
  let newPara = para.trim();
  if (para.startsWith('-')) {
    newPara = para.replace('-', ' ');
  }
  newPara = newPara.trim();
  if (
    newPara.length >= 2 &&
    newPara.charAt(0) == '"' &&
    newPara.charAt(newPara.length - 1) == '"'
  ) {
    newPara = newPara.substring(1, newPara.length - 1);
  }
  return newPara;
};
